import { UAParser } from 'ua-parser-js';
import { getUserAgent } from '../config/helpers';
import { isMobileDevice } from './isMobileDevice';

export const isWindows = () => {
  const userAgent = getUserAgent();
  if (!userAgent) {
    return false;
  }
  const parser = new UAParser(userAgent);
  const result = parser.getResult();
  return result?.os?.name === 'Windows' && !isMobileDevice(navigator.userAgent);
};
